var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-empty',{attrs:{"image":"error","description":"We're sure you are lost. There is nothing here."}})
}
var staticRenderFns = []

export { render, staticRenderFns }